import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "../../Common/DataTable/DataTable";
import Filter from "../AccountTransacctions/TransactionFilter";
import styles from "./report.module.css";
import CustomSpinner from "../../Common/Spinner";
import { finTranTypeID } from "../../utils/utils";
import { InvestingReportColumns } from "../../utils/tableHeader";
import { accountTransactions } from "../../api";
import { format } from "date-fns";
import { addDays } from "date-fns";

function AccountTransaction() {
  const [selectedTransactionType, setSelectedTransactionType] = useState({
    key: "ALL",
    value: "All",
  });
  const [transactionList, setTransactionList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [custId, setCustId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [accountNo, setAccountNo] = useState("");
  const date = new Date();
  const [startDate, setStartDate] = useState(addDays(date, -15));
  const [endDate, setEndDate] = useState(date);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  const getReportTransactions = async (
    custId,
    dateStart,
    dateEnd,
    accountNo,
    selectedTransactionType,
    newOrder,
    pageNumber
  ) => {
    setDataLoading(true);
    try {
      const response = await accountTransactions({
        custId,
        startDate: dateStart,
        endDate: dateEnd,
        accountNo,
        // selectedTransactionType: selectedTransactionType?.key === "ALL" ? "" : selectedTransactionType?.key,
        selectedTransactionType: selectedTransactionType?.key,
        newOrder,
        pageNumber,
        pageSize,
      });
      setDataLoading(false);
      if (response?.data?.code === 400) {
        setErrorMessage(response.data.message);
        setTransactionList([]);
        setTotalPages(1);
        return;
      }
      if (response?.data?.data) {
        setTransactionList(response.data.data?.result || []);
        const totalRecords = response.data.data.totalRecords || 0;
        setTotalPages(Math.ceil(totalRecords / pageSize));
      }
    } catch (e) {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    const dateStart = format(startDate, "yyyy-MM-dd");
    const dateEnd = format(endDate, "yyyy-MM-dd");
    getReportTransactions(
      custId,
      dateStart,
      dateEnd,
      accountNo,
      selectedTransactionType,
      "ASC",
      currentPage
    );
  }, [currentPage]);

  const onSubmit = () => {
    if (startDate && endDate) {
      setErrorMessage("");
      setCurrentPage(1);
      const dateStart = format(startDate, "yyyy-MM-dd");
      const dateEnd = format(endDate, "yyyy-MM-dd");

      getReportTransactions(
        custId,
        dateStart,
        dateEnd,
        accountNo,
        selectedTransactionType,
        "ASC",
        1
      );
      setTransactionList([]);
      setTotalPages(1);
    } else {
      setErrorMessage("Please Select Date");
    }
  };

  return (
    <div>
      <Card className={styles.customCard}>
        <Card.Body className={styles.customCardBody}>
          <Filter
            accountNo={accountNo}
            setAccountNo={setAccountNo}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            onSearch={onSubmit}
            errorMessage={errorMessage}
            finTranTypeID={finTranTypeID}
            selectedTransactionType={selectedTransactionType}
            setSelectedTransactionType={setSelectedTransactionType}
            userId={custId}
            setUserId={setCustId}
          />
        </Card.Body>
      </Card>
      {dataLoading ? (
        <CustomSpinner />
      ) : Array.isArray(transactionList) && transactionList.length > 0 ? (
        <>
          <DataTable
            columns={InvestingReportColumns}
            list={transactionList}
            rowClick={false}
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pagination={true}
            title="Account Transaction Report"
          />
        </>
      ) : (
        <p style={{ color: "white", marginTop: "20px", textAlign: "center" }}>
          No Data Found
        </p>
      )}
    </div>
  );
}

export default AccountTransaction;
